<template>
  <a-entity>
    <a-plane
      :src="cdn(require('./img/play.png'))"
      transparent="true"
      :width="size || .05"
      :height="size || .05"
      ref="play"
      class="Fuse"
      material="shader: flat; depthTest: false"
      :scale="isPlaying ? '0 0 0' : '1 1 1'"
      @click="play"
      opacity="0"
      @materialtextureloaded="show('play')"
    />
    <a-plane
      :src="cdn(require('./img/pause.png'))"
      transparent="true"
      :width="size || .05"
      :height="size || .05"
      ref="pause"
      class="Fuse"
      material="shader: flat; depthTest: false"
      :scale="!isPlaying ? '0 0 0' : '1 1 1'"
      @click="pause"
      opacity="0"
      @materialtextureloaded="show('pause')"
    />
  </a-entity>
</template>

<script>
export default {
  name: 'PlayPause',
  props: ['size'],
  methods: {
    show(type) {
      TweenLite.to(this.$refs[type], 1, { aframe: { alpha: 1 } })
    },
    play() {
      this.$store.commit('app/SET_PLAYING', true)
    },
    pause() {
      this.$store.commit('app/SET_PLAYING', false)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/play_pause/PlayPause.vue